module.exports = __webpack_public_path__ + "scales.jpg?7c75b0dd7a9fee7a25c31e2669aabb75";